import api from 'js/api'

export const cancelSubscription = () => {
  return api('DELETE', 'v2/store/subscription')
}
